import { createSlice } from '@reduxjs/toolkit'
import { cloneDeep, defaultsDeep, merge } from 'lodash'
import { resetProduct } from '../../app/actions'
import { novaApi } from '../../services/novaApi'
import { logout } from '../auth/authSlice'

export const extendedApiSlice = novaApi.injectEndpoints({
	overrideExisting: true,
	endpoints: builder => ({
		getLevelTermIllustration: builder.mutation({
			async queryFn(arg, api, extraOptions, baseQuery) {
				const { auth, term } = api.getState()
				const agent = auth.agent
				const is_fass_user = auth.isFassUser
				const current_agent = auth.currentAgent
				const qid = term?.quote?.qid || ''
				try {
					const response = await baseQuery(
						{
							url: 'term',
							method: 'POST',
							body: { ...arg, agent, qid, current_agent, is_fass_user },
						},
						api,
						extraOptions,
					)
					return response
				} catch (error) {
					return error
				}
			},
		}),
	}),
})

export const { useGetLevelTermIllustrationMutation } = extendedApiSlice

const initialState = {
	plan: {
		sum_assured: '',
		term: '',
		type: '',
	},
	benefits: {
		ad: {
			sum_assured: '',
		},
		wp: false,
		cl: {
			sum_assured: '',
		},
		rr: {
			applicant_age: '',
			additional_premium: '',
		},
	},
	ratings: {
		lt: {
			occrate: '0.00',
			medrate: '0.00',
			avorate: '0.00',
		},
		ad: {
			occrate: '0.00',
			medrate: '0.00',
			avorate: '0.00',
		},
		wp: {
			occrate: '0.00',
			medrate: '0.00',
			avorate: '0.00',
		},
		cl: [
			{
				occrate: '0.00',
				medrate: '0.00',
				avorate: '0.00',
			},
			{
				occrate: '0.00',
				medrate: '0.00',
				avorate: '0.00',
			},
		],
	},
	quote: null,
	is_saved: false,
}

const levelTermSlice = createSlice({
	name: 'term',
	initialState,
	reducers: {
		levelTermPlanUpdated: (state, action) => {
			let newState = cloneDeep(defaultsDeep(action.payload, initialState))

			newState.benefits.wp = newState.benefits?.wp || false

			// prevents resetting quote when illustration is in an error state
			if (!!!newState.quote && !!state.quote) {
				newState.quote = { ...state.quote }
			}

			return merge(state, newState)
		},
		levelTermQuoteUpdated: (state, action) => {
			return merge(state, action.payload)
		},
		termSumAssuredChanged: state => {
			state.benefits.ad.sum_assured = ''
			state.ratings.ad.occrate = '0.00'
			state.ratings.ad.medrate = '0.00'
			state.ratings.ad.avorate = '0.00'
		},
	},
	extraReducers: builder => {
		builder
			.addCase(resetProduct, () => {
				return initialState
			})
			.addCase(logout, state => initialState)
	},
})

export const { levelTermPlanUpdated, levelTermQuoteUpdated, termSumAssuredChanged } =
	levelTermSlice.actions
export const selectLevelTerm = state => state.term
export default levelTermSlice.reducer
